import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=671555ac&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=671555ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671555ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('671555ac')) {
      api.createRecord('671555ac', component.options)
    } else {
      api.reload('671555ac', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=671555ac&scoped=true&", function () {
      api.rerender('671555ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HJMsOZtSTc2m/JS/comp/DocBox.vue"
export default component.exports